import classNames from 'classnames'
import React from 'react'
import { pages } from '../pageNumberForm'


const TabList = ({page}) => {

    const firstTablistClass = classNames({
        'tablistItem': true,
        'active': page === pages.firstPage
    })

    const secondTablistClass = classNames({
        'tablistItem': true,
        'active': page === pages.secondPage
    })

    return (
        <div className="tablist">
            <div className={firstTablistClass}></div>
            <div className={secondTablistClass}></div>
        </div>
    )
}

export default TabList